import { LetteredAvatar } from "./LetteredAvatar";
import { useState } from "react";
import { UserMenuPopup } from "./menu";
import { openClickedItem } from "./helper";
import { MuiIconButton, MuiMenu } from "@dealer-center/core-components";
import { bottomBarlinks } from "../../bottomBar";
import { useNavBarStore } from "../../store";
import type {
  NavigationMenuItemInterface,
  NavigationMenuItemInterfaceNavigate
} from "@dealer-center/ddc-api-commoncontainer-interface";
import { isNavigationMenuItemInterfaceNavigate } from "@dealer-center/ddc-api-commoncontainer-interface";
export const getNavToUse = (
  nav: NavigationMenuItemInterface[],
  showFooter: boolean
): NavigationMenuItemInterface[] => {
  const bottomBarlinksToUse: NavigationMenuItemInterfaceNavigate[] =
    bottomBarlinks.map(link => ({
      label: link.label,
      link: link.href,
      linkType: "open"
    }));
  return (showFooter ? nav : [...bottomBarlinksToUse, ...nav]) || [];
};
const isUserMenuInlineProps = (
  props: UserMenuProps
): props is UserMenuInlineProps => {
  return props.displayMenuInline !== undefined;
};

interface UserMenuInlineProps {
  onItemClicked?: (itemClicked: NavigationMenuItemInterface) => void;
  displayMenuInline?: boolean;
}
type UserMenuProps = UserMenuInlineProps;
export const UserMenu = (props: UserMenuProps) => {
  const { nav, visibility } = useNavBarStore();
  const navToUse = getNavToUse(nav, visibility.showFooter);
  const [anchorProfileEl, setProfileAnchorEl] = useState<null | HTMLElement>(
    null
  );
  if (navToUse.length === 0) return null;
  if (isUserMenuInlineProps(props)) {
    const onItemClicked = props.onItemClicked || (() => undefined);
    return (
      <UserMenuPopup handleItemClicked={onItemClicked} navToUse={navToUse} />
    );
  }
  const menuId = "primary-search-account-menu";

  const handleItemClickedInternal = (
    itemClicked: NavigationMenuItemInterface
  ) => {
    setProfileAnchorEl(null);
    if (isNavigationMenuItemInterfaceNavigate(itemClicked))
      openClickedItem(itemClicked);
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const isProfileMenuOpen = Boolean(anchorProfileEl);

  const renderProfileMenu = (
    <MuiMenu
      keepMounted
      anchorEl={anchorProfileEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      id={menuId}
      open={isProfileMenuOpen}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      onClose={handleItemClickedInternal}
    >
      <UserMenuPopup
        handleItemClicked={handleItemClickedInternal}
        navToUse={navToUse}
      />
    </MuiMenu>
  );
  return (
    <>
      <MuiIconButton
        aria-controls={menuId}
        aria-haspopup="true"
        aria-label="account of current user"
        color="inherit"
        edge="end"
        size="large"
        onClick={handleProfileMenuOpen}
      >
        <LetteredAvatar />
      </MuiIconButton>
      {renderProfileMenu}
    </>
  );
};
